// extracted by mini-css-extract-plugin
export default {"TooltipContent":"CancelSampleModal_TooltipContent__zZbzl"};